import { Country as CountryCode, Currency, getCountryByCountryCode } from '../locale';
import { AccountTypeEnum, UserType } from '../user';
import { randomText } from './randomText';

const currencyToCountryAndLocation: Record<Currency, { country: string; location: CountryCode }> = {
  AUD: { country: getCountryByCountryCode('AU'), location: 'AU' },
  CAD: { country: getCountryByCountryCode('CA'), location: 'CA' },
  EUR: { country: getCountryByCountryCode('DE'), location: 'DE' },
  GBP: { country: getCountryByCountryCode('GB'), location: 'GB' },
  USD: { country: getCountryByCountryCode('US'), location: 'US' },
};

export async function createTestUser(
  email: string,
  {
    apiBaseUrl,
    currency,
    headers,
    parentUserName,
  }: { apiBaseUrl: string; currency?: Currency; headers: Record<string, string>; parentUserName?: string },
): Promise<UserType | null> {
  const url = `${apiBaseUrl}/users/register`;
  const body = {
    type: 'pay-as-you-go',
    customer: {
      emailAddress: email,
      firstName: 'Fname-' + randomText(5),
      lastName: 'Lname-' + randomText(5),
      ...(currency ? currencyToCountryAndLocation[currency] : currencyToCountryAndLocation['GBP']),
    },
    user: {
      groupName: 'Bname-' + randomText(5),
      isMarketingAccepted: false,
      password: 'Pword-' + randomText(5),
      accountType: AccountTypeEnum.BUSINESS,
      ...(parentUserName && { parent: parentUserName }),
    },
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  console.log(`PAYG user successfully created: ${email}`);
  const { data } = await response.json();
  return data.user;
}
